export class VisibilityModel {
  id: Number;
  program_id: Number;
  element_type: Number;
  posm_audit_type: String;
  posm_image_template: String;
  posm_image_banner: String;
  image_planogram: String;
  channels: any;
}

export class ChillerSelectionModel {
  id: number;
  selection_value: string;
  status: number;
  created_date: string;
  updated_date: string;
  purity_type: number;
  statusString: string;
  chiller_year: string;
  chiler_month: string;
  is_competitive_cooler: number;
  competitiveString: string;
}

export class ChillerRegionwiseScheme {
  id: number;
  region_id: number;
  region_name: string;
  points: number;
  chiller_pure_impure_selection_id: number;
  chiller_pure_impure_selection_name: string;
  start_date: any;
  end_date: any;
  startDate: any;
  endDate: any;
  state_code: string;
  state_name: string;
  created_date: string;
  updated_date: string;
  statusString: string;
  geo_group_id: number;
  geo_group_name: string;
  status: any;
}

export class ChillerScheme {
  id: number;
  scheme_name: string;
  status: any;
  start_date: any;
  end_date: any;
  created_date: string;
  update_date: string;
  statusString: string;
  show: boolean;

}

export class PosmAudityTypesModel {
  id: number;
  posm_image_template: any;
  posm_image_banner: any;
  image_planogram: any;
  status: any;
  program_id: number;
  campaign_id: number;
  is_campaign: number;
  chiller_id: number;
  chiller_name: string;
  posm_element_config_id: number;
  channel_id: number;
  channel_name: string;
  created_date: string;
  updated_date: string;
  threshold_value: string;
  posm_audit_type: string;
  posm_type_indicate: string;
  posm_type: string;
  statusString: string;
  region_name: string;
  state_name: string;
  region_id: number;
  state_code: number;
}

export class PosmAuditConfigurationModel {
  channel_name: string;
  created_date: string;
  end_date: string;
  frequency: number;
  id: number;
  points: number;
  posm_audit_type: string;
  posm_element_config_id: number;
  posm_type: string;
  region_id: number;
  region_name: string;
  start_date: string;
  state_code: string;
  state_name: string;
  state_year: string;
  status: any;
  updated_date: string;
  statusString: string;
  startDate: any;
  endDate: any;
  channel_id: number;
  posm_type_name: string;
  chiller_month: number;
  chiller_year: number;
  show: boolean;
}

export class GeoGroupModel {
  id: number;
  status: number;
  created_date: string;
  updated_date: string;
  group_name: string;
}

export class ChillerBonusAssignedUsersModel {
  id: number;
  user_id: number;
  chiller_bonus_selection_id: number;
  chiller_bonus_scheme_id: number;
  bonus_points: number;
  status: any;
  created_date: string;
  update_date: string;
  ro_name: any;
  ro_code: any;
}

export class chillerBonusPointSchemeModel {
  id: number;
  scheme_name: string;
  start_date: string;
  end_date: string;
  status: any;
  created_date: string;
  update_date: string;
  startDate: any;
  endDate: any;
  excel: any;
  items: any;
  statusString: string;
  show: boolean;
  chiller_month : number;
  chiller_year : number;
}

export class ChillerUserWiseBounsPointModel {
  id: number;
  user_id: number;
  chiller_bonus_selection_id: number;
  chiller_bonus_scheme_id: number;
  bonus_points: number;
  status: any;
  created_date: string;
  update_date: string;
  chiller_bonus_selection_name: string;
  chiller_bonus_scheme_name: string;
  isEdit: boolean;
  ro_name: any;
  ro_code: any;
  statusString: string;
  show: boolean;
}
